import React from "react";
import {
  Row,
  Col,
  Drawer,
  Form,
  Input,
  Button,
  Select,
  Spin,
  message
} from "antd";
import Helmet from "react-helmet";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { API } from "aws-amplify";
import { sessionActions } from "redux/modules/session";
import { SHIPPING } from 'config';
import * as Styled from "./styled";

const FormItem = Form.Item;
const Option = Select.Option;

const SHIP_OPTIONS = ["1 Day", "Express", "Standard Shipping","Free shipping (USPS First Class Mail)"];

const ShippingForm = ({ handleSubmit, form, saving, store, labData }) => {
  const { getFieldDecorator } = form;

  if (!labData) return <Spin />;

  const intlOption = labData.shipping.find(
    s => s.pos_code === "int1stclassfbq"
  );

  return (
    <Form onSubmit={handleSubmit}>
      <h4>US Shipping</h4>
      {SHIP_OPTIONS.map(o => (
        <Row gutter={12} key={o}>
          <Col span={12}>
            <FormItem>
              <Input disabled value={o} />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem>
              {getFieldDecorator(`shippingOptions.${o}`, {
                initialValue: store.shippingOptions && store.shippingOptions[o]
              })(
                <Select placeholder="Please select">
                  {labData.shipping.map(s => (
                    <Option key={s.pos_code} value={s.pos_code}>
                      {s.shippingmethod} ${s.price}
                    </Option>
                  ))}
                </Select>
              )}
            </FormItem>
          </Col>
        </Row>
      ))}
      <FormItem>
        <h4>International*</h4>
        <p>* Please note that shipping prices below are based on the package being under 1 pound!</p>
        <ul>
          {Object.keys(SHIPPING).map(key => (
            <li key={key}>
              <strong>{key} - </strong> <span>${SHIPPING[key]}</span>
            </li>
          ))}
        </ul>
      </FormItem>
      <Button loading={saving} size="large" htmlType="submit" type="primary">
        Submit
      </Button>
    </Form>
  );
};

class StoreShipping extends React.Component {
  state = {
    saving: false
  };

  onClose = () => {
    this.props.dispatch(push("/settings/stores"));
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ saving: true });
        API.put("api", `stores/${this.props.match.params.storeId}`, {
          body: values
        }).then(
          resp => {
            this.props.dispatch(sessionActions.setStore(resp));
            message.success("Store updated");
            this.setState({
              saving: false
            });
            this.onClose();
          },
          e => {
            message.error(e.response.data.message);
          }
        );
      }
    });
  };

  render() {
    const { stores, currentStoreId, labData } = this.props;
    const store = stores.find(s => s.storeId === currentStoreId);

    return (
      <Drawer
        visible
        title="Shipping mapping"
        width={600}
        onClose={this.onClose}
        style={{
          overflow: "auto",
          height: "calc(100% - 108px)",
          paddingBottom: "108px"
        }}
      >
        <Styled.Container>
          <Helmet title="Shipping settings"/>
          <p>
            Map your store shipping options with the corresponding shipping option
            we provide. Your defaults should use Drop Ship not Standard Ship. Drop Ship means we ship to your customer, Standard Ship would ship back to you.
          </p>
          <p>Please note that Express shipping is based on your package being less than 1 pound! Prints larger than 12x18 and Canvas wraps will be charged at the rate below or actual cost which ever is more.</p>
          <ShippingForm
            labData={labData}
            store={store}
            form={this.props.form}
            handleSubmit={this.handleSubmit}
            saving={this.state.saving}
          />
        </Styled.Container>
      </Drawer>
    );
  }
}

export default connect(state => ({
  ...state.session,
  ...state.lab
}))(Form.create()(StoreShipping));
